import { api } from "../../services/Api.js";

export function get_calendar_item({ commit, state }, payload){

    // add token to payload
    payload.token=state.appSettings.token

    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    
    // return chainable promise
    return api.post(school,"get_calendar_item.php",payload).then(
      result=>{
       
        commit("SET_CALENDAR_ITEM",result.data);

        // make chainable
        return result;
    })

  
    
}